module.exports = __webpack_public_path__ + "media/src/images/icons/yellow-alert-triangle-6065244d187bd3d91a237f63efdd5cd4.svg";